import React, { Component } from 'react';
import ListAlerts from '../components/Alerts/ListAlerts';
import {Tabs , Row ,Col} from 'antd'
import TopNavBar from '../components/TopNavBar';
import AlertLog from '../components/Alerts/AlertLog';

const {TabPane} = Tabs


class Alerts extends Component{

    navigate = (link) =>{
        this.props.history.push(link)
    }

    render(){
        return (
            <>
            <TopNavBar navigate={this.navigate} title={"Alerts"}/>
                <Row style={{padding:"50px"}}>
                    <Col>
                        <Tabs>
                            <TabPane tab="List Alerts" key="listAlerts">
                                <ListAlerts/>
                            </TabPane> 
                            <TabPane tab="Alert Log" key="alertLog">
                                <AlertLog />
                            </TabPane> 
                        </Tabs>
                    </Col>
                </Row>
            </>
        )
    }

}

export default Alerts